import React, { useState, useEffect } from 'react';
import { Button } from '@material-ui/core';
import { createPortal } from 'react-dom';
import { Edit as EditIcon, Close } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateOrAny } from 'react-redux';
import { toggleOperationHoursViewMode } from '../../redux/actions/newOperationHoursActions';
import OperationHoursViewTab from '../OperationHoursViewTab/OperationHoursViewTab';
import OperationHoursTab from '../OperationHoursTab';
import WeekSelector from '../WeekSelector';
import RamAssistant from '../RamAssistant';
import RestaurantInfoCard from './RestaurantInfoCard';
import { useStyles } from './styles';
import { useTranslation } from 'react-i18next';

function OperationHoursMaster() {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isEditMode, setIsEditMode] = useState<boolean>(false);
  const [selectedWeek, setSelectedWeek] = useState<Date>(new Date());

  const restaurant = useSelector(
    (state: RootStateOrAny) => state.RestaurantsReducer.entity,
  );

  const { thisUser } = useSelector(
    (state: RootStateOrAny) => state.UserReducer,
  );

  const { shouldSwitchToViewMode } = useSelector(
    (state: RootStateOrAny) => state.NewOperationHoursReducer,
  );

  const handleEditClick = () => {
    setIsEditMode(true);
  };

  const handleCancelEdit = () => {
    setIsEditMode(false);
  };

  const handleWeekChange = (week: Date) => {
    setSelectedWeek(week);
  };

  // Handle switching to view mode when save is successful
  useEffect(() => {
    if (shouldSwitchToViewMode) {
      setIsEditMode(false);
      // Reset the flag
      dispatch(toggleOperationHoursViewMode(false));
    }
  }, [shouldSwitchToViewMode, dispatch]);

  return (
    <>
      <div className={classes.root}>
        <div className={classes.headerContainer}>
          <RestaurantInfoCard restaurant={restaurant} />

          <div className={classes.controlsContainer}>
            {!isEditMode && (
              <WeekSelector
                selectedWeek={selectedWeek}
                onWeekChange={handleWeekChange}
              />
            )}

            {thisUser.hasEditHoursOfOperation && (
              <Button
                variant="contained"
                className={classes.editButton}
                startIcon={isEditMode ? <Close /> : <EditIcon />}
                onClick={isEditMode ? handleCancelEdit : handleEditClick}
              >
                {isEditMode ? t('app.common.cancel') : t('Edit')}
              </Button>
            )}
          </div>
        </div>

        <div className={classes.contentContainer}>
          {isEditMode ? (
            <OperationHoursTab />
          ) : (
            <OperationHoursViewTab selectedWeek={selectedWeek} />
          )}
        </div>
      </div>

      {createPortal(<RamAssistant />, document.body)}
    </>
  );
}

export default OperationHoursMaster;
